import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import type ApiCategory from 'src/core/models/api/ApiCategory';
import { reportToCallerOrCrashlytics } from 'src/domain/stores/StoreErrorChannel';
import { useContentStore } from 'src/domain/stores/useContentStore';
import type ApiRequestError from 'src/core/models/api/ApiRequestError';

const initialState = {
	selectedCategory: null as ApiCategory | null,
	entranceKey: 0,
};

export const useInspirationStore = create(
	combine({ ...initialState }, (set, get) => {
		const reset = () => set({ ...initialState });

		const init = () => reset();

		const getInspiration = ({
			onSuccess,
			onError,
			onFinally,
		}: {
			onSuccess?: () => void;
			onError?: (error: ApiRequestError) => void;
			onFinally?: () => void;
		} = {}): void => {
			useContentStore
				.getState()
				.getApiInspiration({
					onSuccess: () => {
						reselectCategory();
						onSuccess?.();
					},
					onFinally: () => onFinally?.(),
				})
				.catch((error: ApiRequestError) =>
					reportToCallerOrCrashlytics({ message: 'Fetching the inspiration page failed.', error, onError }),
				);
		};

		const reselectCategory = () => {
			const categories = useContentStore.getState().inspiration?.data?.categories ?? [];
			const selectedId = get().selectedCategory?.id ?? null;

			set({ selectedCategory: categories.find((category) => category.id === selectedId) ?? categories[0] ?? null });
		};

		const setSelectedCategory = (selectedCategory: ApiCategory) => set({ selectedCategory });

		const replayEntrance = () => set({ entranceKey: get().entranceKey + 1 });

		return {
			init,
			getInspiration,
			setSelectedCategory,
			replayEntrance,
			reset,
		};
	}),
);
